<template>
  <dialog :open="open" class="modal modal-bottom sm:modal-middle">
    <div class="modal-box">
      <div v-if="modalState.type === 'loading'" class="flex flex-col items-center justify-center">
        <span class="loading loading-spinner loading-lg mb-4 text-primary"></span>
        <h3 class="font-bold text-lg mb-2">{{ modalState.title }}</h3>
        <p class="text-sm text-gray-500 mb-4">{{ t('aiChatAgentSetup.loadingModal.doNotClose') }}</p>
        <p class="text-sm text-gray-600">{{ currentTip }}</p>
      </div>
      <div v-else-if="modalState.type === 'error'" class="flex flex-col items-center justify-center text-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-16 w-16 text-error mb-4" fill="none" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 class="font-bold text-lg mb-2 text-error">{{ modalState.title }}</h3>
        <p class="text-sm text-gray-700 dark:text-gray-300 py-4">{{ modalState.message }}</p>
        <div class="modal-action mt-4 justify-center">
          <button class="btn" @click="$emit('close')">{{ t('aiChatAgentSetup.loadingModal.closeButton', 'Close') }}</button>
        </div>
      </div>
    </div>
    <div class="modal-backdrop bg-black bg-opacity-50 fixed inset-0" @click.prevent.stop="handleBackdropClick"></div>
  </dialog>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useI18n } from '@/i18n';

const props = defineProps({
  open: Boolean,
  modalState: Object,
  currentTip: String,
  closeOnBackdrop: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits(['close']);
const { t } = useI18n();

function handleBackdropClick() {
  if (props.closeOnBackdrop === true) {
    emit('close');
  }
}
</script> 